import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RecentPoliciesState } from './recent-policies.reducer';

export const selectRecentPoliciesState = createFeatureSelector<RecentPoliciesState>('recentPolicies');

export const selectRecentPolicies = createSelector(selectRecentPoliciesState, (state) => state.policies);
